<template>
  <div class="app-container-v2 process-content-container">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">发票信息</span>
      </div>
    </div>

    <div class="flex vertical p24 table-body" v-loading="loading">
      <air-table
          v-if="render"
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
      >
        <template #operation="{ row }">
          <div v-if="row.invoiceMedium === '30310002'" class="flex center mt4">
            <span class="text-button" @click="handleDownload(row)">下载发票</span>
          </div>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      render: false,
      loading: false,
      queryParams: {
        page: 1,
        limit: 10,
      },
      total: 0,
      columns: [
        {title: '发票编号', field: 'id', minWidth: 150, filterType: 'input'},
        {title: '发票抬头', field: 'invoiceTitleName', minWidth: 100, filterType: 'input'},
        {title: '发票类型', field: 'invoiceTypeText', minWidth: 100, filterType: 'select', filterOptions: []},
        {title: '发票介质', field: 'invoiceMediumText', minWidth: 100, filterType: 'select', filterOptions: []},
        {title: '总额', field: 'amount', money: true, minWidth: 100},
        {title: '备注', field: 'remark', minWidth: 100},
        {title: '快递单号', field: 'courierNum', minWidth: 120},
        {title: '开票时间', field: 'invoiceDate', minWidth: 120},
      ],
      tableData: [],
      dictMap: {}
    }
  },
  watch: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.orderId = this.data.orderInfo.id
      this.getData()
    },
    getData() {
      this.loading = true
      api.queryInvoiceList(this.queryParams).then(res => {
        const data = res.data.data
        if (!this.dictMap.invoiceType) {
          this.dictMap.invoiceType = this.$arrayToObj(data.invoiceCodeItems['3030'], 'codeItemId')
          this.dictMap.invoiceMedium = this.$arrayToObj(data.invoiceCodeItems['3031'], 'codeItemId')
          this.columns[2].filterOptions = data.invoiceCodeItems['3030']
          this.columns[3].filterOptions = data.invoiceCodeItems['3031']
        }
        this.tableData = this.$handleTableDict(data.invoiceDetailList, this.dictMap)
        this.total = data.params.total
        this.loading = false
        this.render = true
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    handleDownload(row) {
      this.$msgInfo('开始下载...')
      api.downloadInvoice(row.id).then(res => {
        this.$downloadFile(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.order-info-container {
  .order-info-box:last-child {
    margin-bottom: 40px;
  }
}
.title-block {
  width: 4px;
  height: 14px;
  background: #0093AB;
  border-radius: 2px;
}
.file-list-container {
  background: #F8F9FA;
  border-radius: 4px;
  padding: 30px 20px;

  .file-box:last-child {
    margin-bottom: 0;
  }
}
</style>
